import { createSlice } from '@reduxjs/toolkit';
import { ProductPageModel } from '../../Types/ProductPageModel';
import { setActiveProduct } from './Actions/setActiveProduct.action';

interface ProductPageState {
  currentProduct?: ProductPageModel;
  isLoadingProduct: boolean;
  loadProductError?: string;
  loadingProductId?: string;
}

const DEFAULT_STATE: ProductPageState = {
  isLoadingProduct: false,
};

const productPageSlice = createSlice({
  name: 'productPage',
  initialState: DEFAULT_STATE,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(setActiveProduct.fulfilled, (state, action) => {
      state.currentProduct = action.payload.response;
      state.loadingProductId = undefined;
      state.isLoadingProduct = false;
    });
    builder.addCase(setActiveProduct.pending, (state, action) => {
      state.loadingProductId = action.meta.arg.id;
      state.isLoadingProduct = true;
    });
    builder.addCase(setActiveProduct.rejected, (state, action) => {
      state.loadingProductId = undefined;
      state.isLoadingProduct = false;
    });
  },
});

export const productPageActions = productPageSlice.actions;

export default productPageSlice.reducer;
